import MaterialTableHeader from "./MTableHeader";
import MaterialTableBody from "./MaterialTableBody";
import MaterialTableBodyOriginal from "./m-table-body";
import MaterialTableBodyRow from "./MaterialTableBodyRow";
import MaterialTableEditRow from "./MTableEditRow";
import MaterialTableEditField from "./m-table-edit-field";
import MaterialTableCell from "./MTableCell";
import MaterialTableButtonBar from "./MaterialTableButtonBar";
import MaterialTableSummaryRow from "./MaterialTableSummaryRow";
import {FullWidthFilter} from "./MaterialTableFilters";

const defaultComponentsScroll = {
  Header: MaterialTableHeader,
  Body: MaterialTableBody,
  Row: MaterialTableBodyRow,
  Cell: MaterialTableCell,
  EditRow: MaterialTableEditRow,
  EditField: MaterialTableEditField,
  ButtonBar: MaterialTableButtonBar,
}

const defaultComponents = {
  Header: MaterialTableHeader,
  Body: MaterialTableBody,
  Row: MaterialTableBodyRow,
  Cell: MaterialTableCell,
  EditRow: MaterialTableEditRow,
  EditField: MaterialTableEditField,
}

export {
  MaterialTableCell,
  MaterialTableHeader,
  MaterialTableBody,
  MaterialTableBodyOriginal,
  MaterialTableBodyRow,
  MaterialTableEditRow,
  MaterialTableEditField,
  MaterialTableButtonBar,
  MaterialTableSummaryRow,
  defaultComponents,
  defaultComponentsScroll,
  FullWidthFilter
}